import PropTypes from 'prop-types';

const Modules = ({modules,activeModule,setActiveModule}) => {
    return (
        <div className="modules chart-wrapper-buttons sb1-mb-1">
            {modules.map((module,i)=>
                <button 
                    key={`module-button-${i}`} 
                    className={(i===activeModule ? "btn btn-primary active rounded-pill button button--white button--is-active" : "btn btn-primary rounded-pill button button--white")}
                    aria-current="page"
                    onClick={()=>setActiveModule(i)}
                >
                    {module.name}
                </button>
            )}
        </div>
    )
}
export default Modules;

Modules.propTypes = {
    modules: PropTypes.array.isRequired,
    setActiveModule: PropTypes.func.isRequired,
    activeModule: PropTypes.number.isRequired
}